function stdin_default(hiprint) {
  return function(options) {
    var addElementTypes = function(context) {
      context.removePrintElementTypes("defaultModule");
      context.addPrintElementTypes("defaultModule", [
        new hiprint.PrintElementTypeGroup("\u5E38\u89C4", [
          {
            tid: "defaultModule.text",
            title: "\u6587\u672C",
            data: "",
            type: "text"
          },
          {
            tid: "defaultModule.textVal",
            title: "\u503C\uFF08\u6587\u672C\uFF09",
            data: "",
            type: "text",
            options: {
              hideTitle: true
            }
          },
          {
            tid: "defaultModule.barcode",
            title: "\u6761\u5F62\u7801",
            data: "",
            type: "text",
            options: {
              field: "barcode",
              testData: "lkforntend",
              height: 32,
              fontSize: 12,
              lineHeight: 18,
              textType: "barcode"
            }
          },
          {
            tid: "defaultModule.qrcode",
            title: "\u4E8C\u7EF4\u7801",
            data: "",
            type: "text",
            options: {
              testData: "\u529B\u63A7\u5143\u6D77-\u6280\u672F\u4E2D\u5FC3-\u524D\u7AEF",
              field: "qrcode",
              width: 50,
              height: 50,
              textType: "qrcode"
            }
          },
          {
            tid: "defaultModule.image",
            title: "\u56FE\u7247",
            data: "",
            type: "image"
          },
          {
            tid: "defaultModule.longText",
            title: "\u957F\u6587",
            data: "155123456789",
            type: "longText"
          },
          {
            tid: "defaultModule.table",
            field: "table",
            title: "\u8868\u683C",
            type: "table",
            columns: [
              [
                {
                  title: "",
                  width: 100
                },
                {
                  title: "",
                  width: 100
                }
              ]
            ],
            editable: true,
            tableBorder: "border",
            columnDisplayEditable: true,
            //列显示是否能编辑
            columnDisplayIndexEditable: true,
            //列顺序显示是否能编辑
            columnTitleEditable: true,
            //列标题是否能编辑
            columnResizable: true,
            //列宽是否能调整
            columnAlignEditable: true,
            //列对齐是否调整
            isEnableEditField: true,
            //编辑字段
            isEnableContextMenu: true,
            //开启右键菜单 默认true
            isEnableInsertRow: true,
            //插入行
            isEnableDeleteRow: true,
            //删除行
            isEnableInsertColumn: true,
            //插入列
            isEnableDeleteColumn: true,
            //删除列
            isEnableMergeCell: true
            //合并单元格
          },
          {
            tid: "defaultModule.emptyTable",
            field: "table",
            title: "\u7A7A\u767D\u8868\u683C",
            type: "table",
            columns: [
              [
                {
                  title: "",
                  field: "",
                  width: 100
                },
                {
                  title: "",
                  field: "",
                  width: 100
                }
              ]
            ]
          },
          {
            tid: "defaultModule.html",
            title: "html",
            formatter: function(data, options2) {
              return "<div></div>";
            },
            type: "html"
          },
          {
            tid: "defaultModule.customText",
            title: "\u81EA\u5B9A\u4E49\u6587\u672C",
            customText: "\u81EA\u5B9A\u4E49\u6587\u672C",
            custom: true,
            type: "text"
          }
        ]),
        new hiprint.PrintElementTypeGroup("\u8F85\u52A9", [
          {
            tid: "defaultModule.hline",
            title: "\u6A2A\u7EBF",
            type: "hline"
          },
          {
            tid: "defaultModule.vline",
            title: "\u7AD6\u7EBF",
            type: "vline"
          },
          {
            tid: "defaultModule.rect",
            title: "\u77E9\u5F62",
            type: "rect"
          },
          {
            tid: "defaultModule.oval",
            title: "\u692D\u5706",
            type: "oval"
          }
        ])
      ]);
    };
    return {
      addElementTypes
    };
  };
}
export {
  stdin_default as default
};
